import { RouterOutlet } from '@angular/router';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { ThemeModeService } from './core/services/layout';
import { TranslationService } from './core/services/translation';
// language list
import { enLocale as enLang } from './core/models/translate/vocabs/en';
import { arLocale as arLang } from './core/models/translate/vocabs/ar';

@Component({
   // tslint:disable-next-line:component-selector
   // eslint-disable-next-line @angular-eslint/component-selector
   selector: 'body[root]',
   templateUrl: './app.component.html',
   styleUrl: './app.component.scss',
   changeDetection: ChangeDetectionStrategy.OnPush,
   standalone: true,
   imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
   constructor(private readonly translationService: TranslationService, private readonly modeService: ThemeModeService) {
      // register translations
      this.translationService.loadTranslations(
         enLang,
         arLang,
      );
   }

   ngOnInit() {
      this.modeService.init();
   }
}
